__turbopack_context__.v({
  "className": "MPvmrq_className",
  "variable": "MPvmrq_variable",
});
